import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const NewItem = ({ item }) => {
  const timeLeft = item.expiryDate || 0;
  const [hours, setHours] = useState(null);
  const [minutes, setMinutes] = useState(null);
  const [seconds, setSeconds] = useState(null);
  
  const expiryDateExists = timeLeft > 0;

  function startCountdown() {
    const millisLeft = timeLeft - Date.now();
    const secondsLeft = millisLeft / 1000;
    const minsLeft = secondsLeft / 60;
    const hoursLeft = minsLeft / 60;

    setSeconds(Math.floor(secondsLeft) % 60);
    setMinutes(Math.floor(minsLeft) % 60);
    setHours(Math.floor(hoursLeft));
  }

  console.log(item.expiryDate);

  useEffect(() => {
    if (expiryDateExists) {
      let intervalId = setInterval(startCountdown, 1000);
      return () => clearInterval(intervalId);
    }
  }, []);

  return (
    <div>
      <div className="nft__item">
        <div className="author_list_pp">
          <Link
            to={`/author/${item.authorId}`}
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Creator: Monica Lucas"
          >
            <img className="lazy" src={item.authorImage} alt="" />
            <i className="fa fa-check"></i>
          </Link>
        </div>

        {expiryDateExists && (
          <div className="de_countdown">
            <div>
              {hours}h {minutes}m {seconds}s
            </div>
          </div>
        )}

        <div className="nft__item_wrap">
          <div className="nft__item_extra">
            <div className="nft__item_buttons">
              <button>Buy Now</button>
              <div className="nft__item_share">
                <h4>Share</h4>
                <a href="#" target="_blank" rel="noreferrer">
                  <i className="fa fa-facebook fa-lg"></i>
                </a>
                <a href="#" target="_blank" rel="noreferrer">
                  <i className="fa fa-twitter fa-lg"></i>
                </a>
                <a href="#">
                  <i className="fa fa-envelope fa-lg"></i>
                </a>
              </div>
            </div>
          </div>

          <Link to={`/item-details/${item.nftId}`}>
            <img
              src={item.nftImage}
              className="lazy nft__item_preview"
              aria-label="View creator profile"
            />
          </Link>
        </div>
        <div className="nft__item_info">
          <Link to={`/item-details/${item.nftId}`}>
            <h3>{item.title}</h3>
          </Link>
          <div className="nft__item_price">{item.price} ETH</div>
          <div className="nft__item_like">
            <i className="fa fa-heart"></i>
            <span>{item.likes}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewItem;